<ion-content class="modal-options ion-padding">
  @if (hasPendingDeletePetition) {
  <div class="edit-petition-warning">
    <div class="image-wrapper">
      <img
        src="assets/images/scanner-result-warning.svg"
        class="icon-animation"
        alt="Advertencia"
      />
    </div>
    <p class="title">
      {{ "delete-ticket-modal.pending-delete-title" | translate }}
    </p>
    <p class="warning-message">
      {{ "delete-ticket-modal.pending-delete" | translate }}
    </p>
  </div>
  } @else {
  <div class="modal-form-container">
    <div class="content-top">
      <h3 class="title font-heavitas">{{ ticket.product.name }}</h3>
      @if (shouldShowReference()) {
      <p class="reference">
        {{ ticket.reference }}
      </p>
      }
      <p class="price">{{ getTicketAmount(ticket) | arsCurrency }}</p>
      <!-- Alert -->
      <app-info-alert
        [message]="'delete-ticket-modal.alert' | translate"
        type="warning"
      />
      <!-- Form -->
      <div class="message-container">
        <app-reason-textarea
          [control]="reasonControl"
          [label]="'delete-ticket-modal.form.label' | translate"
          [placeholder]="'delete-ticket-modal.form.placeholder' | translate"
        />
      </div>
    </div>
    <!-- Buttons -->
    <div class="buttons-bottom">
      <app-main-button
        [label]="'delete-ticket-modal.send'"
        (clicked)="onSubmitDeletePetition()"
      />
    </div>
  </div>
  }
</ion-content>
